import React from 'react';
import Modal from './Modal';

const ServiceModal = ({ isOpen, onClose, title, description }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} style={{height: '100%'}}>
      <div>{description}</div>
    </Modal>
  );
};

export default ServiceModal; 